import React from 'react';

const processing = (props) => {

	let classes = 'processing';
	if(props.colour) classes += ' processing--' + props.colour;

	return (
		<div className={classes}>
			<span className='processing__inner'><i className='fas fa-circle-notch'></i></span>
			<span className='processing__outer'><i className='fas fa-circle-notch'></i></span>
		</div>
	);
}

export default processing;


// WEBPACK FOOTER //
// ./src/UI/Processing.js